import type { SyntheticEvent } from 'react';

export default <T, D extends SyntheticEvent>(cb: (e: D) => T) =>
    (e: D) => {
        e.preventDefault();

        return cb(e);
    };
